import React, { useEffect } from 'react'
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ListLayout from "../../../components/common/List/List-Layout";
import { useGetAdminPlanListQuery ,useDeletePlanMutation } from '../../../store/api/adminplan'
import ConfirmationModal from '../../../components/common/List/DeletePopup'
import Table from '../../../components/common/List/Table';
function AdminPlan() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [sortKey, setSortKey] = useState('created_at');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteid, setdeleteid] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [deletePlan] = useDeletePlanMutation();
  const { data: tabledata, isLoading, refetch } = useGetAdminPlanListQuery({
    page: currentPage,
    page_size: pageSize,
    sort: sortKey,
  });
  console.log(tabledata,"tabledata"
  );
  
  const handleDelete = async () => {
    try {
      await deletePlan(deleteid.id);
      setIsModalOpen(false);
      refetch()
    } catch (error) {
      refetch();
    }
  };

  const handleSort = (key) => {
    if (sortKey !== key) {
      setSortKey(key);
    }
  };
  const tableHeaders = [
    { label: "S.NO", key: "serial_no", increameant: true, placeholder: "S.NO" },
    { label: "Gym Name", key: "plan_name", sortable: false },
    { label: "Plan Type", key: "plan_type", sortable: false },
    { label: "Plan Duratiom", key: "plan_duration_type", sortable: false },

  ];
  const actionButtons = [
    {
      icon: "MdOutlineRemoveRedEye",
      onClick: (row) => navigate("/view-adminplan", { state: { data: row , pageName: "Admin Plan" }  }),
    },
    {
      icon: "MdOutlineModeEdit",
      onClick: (row) => {
        navigate("/edit-adminplan", { state: { data: row , pageName: "Admin Plan" }  });
      },
    },

    {
      icon: "RiDeleteBinLine",
      onClick: (row) => {
        setdeleteid(row);
        setIsModalOpen(true);
      },
    },
  ];

  const Buttons = [
    {
      title: "+ Add Plan",
      design:
        "px-2 text-base py-1.5 bg-secondary font-normal text-white rounded hover:bg-secondary-700 flex items-center gap-1",
      onClick: () =>
        navigate("/create-adminplan", { state: { pageName: "Admin Plan" } }),
    },
  ];
  useEffect(()=>{
    refetch();
  },[])
  return (
    <>
      <ListLayout
        title="Admin Plan List"
        Buttons={Buttons}
        tableHeaders={tableHeaders}
        tabledata={tabledata?tabledata.data : []}
        actionButtons={actionButtons}
        currentPage={currentPage}
        totalrecords={tabledata?.count}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSort={handleSort}
        sortKey={sortKey}
        isLoading={isLoading}
      />
      {isModalOpen && (
          <ConfirmationModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={handleDelete}
          />
        )}
    </>

  )
}

export default AdminPlan
